import HtmlToReact from 'html-to-react';

// eslint-disable-next-line import/no-cycle
import { addClosingTags, processingList, changeNot } from './templateHelper';

const HtmlToReactParser = HtmlToReact.Parser;
const htmlToReactParser = new HtmlToReactParser();

const isValidNode = () => true;

const TemplateParser = (props) => {
  const { products, collection, template, settings } = props;

  let newTemplate = addClosingTags(template);
  newTemplate = changeNot(newTemplate);

  return htmlToReactParser.parseWithInstructions(
    newTemplate,
    isValidNode,
    processingList(products, collection, 'Personalization Block', settings)
  );
};

export default TemplateParser;
